app.component("primaryIndication", {
	templateUrl: "app/src/js/components/operationNote/eyeBank/commonComponents/primaryIndication/primaryIndication.html",
	controller: "primaryIndicationController",
	bindings: {
		data: "<",
		eyeTitle: "@",
	},
});

app.controller("primaryIndicationController", [
	"$scope",
	"PRIMARY_INDICATION_FOR_SURGERY_OPTICAL",
	"PRIMARY_INDICATION_FOR_SURGERY_TECTONIC",
	"PRIMARY_INDICATION_FOR_SURGERY_THERAPEUTIC",
	"PRIMARY_INDICATION_FOR_SURGERY_GRAFT",
	"PRIMARY_INDICATION_FOR_SURGERY_OTHER",
	function (
		$scope,
		PRIMARY_INDICATION_FOR_SURGERY_OPTICAL,
		PRIMARY_INDICATION_FOR_SURGERY_TECTONIC,
		PRIMARY_INDICATION_FOR_SURGERY_THERAPEUTIC,
		PRIMARY_INDICATION_FOR_SURGERY_GRAFT,
		PRIMARY_INDICATION_FOR_SURGERY_OTHER
	) {

        $scope.primaryOptions = [
			{ value: "OPTICAL", name: "Optical / Visual Restoration", options: PRIMARY_INDICATION_FOR_SURGERY_OPTICAL },
			{ value: "TECTONIC", name: "Tectonic / Reconstructive", options: PRIMARY_INDICATION_FOR_SURGERY_TECTONIC },
			{ value: "THERAPEUTIC", name: "Therapeutic", options:  PRIMARY_INDICATION_FOR_SURGERY_THERAPEUTIC},
			{ value: "GRAFT", name: "Graft Management", options: PRIMARY_INDICATION_FOR_SURGERY_GRAFT },
			{ value: "OTHER", name: "Other", options: PRIMARY_INDICATION_FOR_SURGERY_OTHER },
		];

		this.$onInit = function () {
          
        };
	},
]);
